module.exports = __webpack_public_path__ + "img/label-property.5cc19efa.jpg";